import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class BudgetsTableHeader extends Component {

  static Layout = [
    { column: "contractStartDate", width: 2, name: "Contract Start Date" },
    { column: "contractEndDate", width: 2, name: "Contract End Date" },
    { column: "utilityAlias", width:2, name: "Utility" },
    { column: "budgetLowerLimit", width: 2, name: "Lower Limit" },
    { column: "budget", width: 2, },
    { column: "budgetUpperLimit", width: 2, name: "Upper Limit" },
    { column: "liveMarketCostPerUnit", width: 1, name: "Live Market Costing" },
    { column: "budgetStatus", width: 1, name: "Budget Status" }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={BudgetsTableHeader.Layout}/>
    )
  }
}